/**
 * Domain models. These are what components, stores and hooks work with —
 * camelCase, no wire envelope, no optional-key archaeology.
 */

export type Cell = string | number | boolean | null

export interface QueryResultSet {
  columns: string[]
  rows: Cell[][]
  /** Total rows the SQL matched, before the backend's display cap. */
  rowCount: number
  /** Rows actually present in `rows`. */
  displayedRowCount: number
  truncated: boolean
  note?: string
}

export interface QueryAnalysis {
  hasResults: boolean
  usedLlm: boolean
  isConversational: boolean
  /** "DETERMINISTIC" when the deterministic formatter produced the answer. */
  analysisMode?: string
  /** Follow-up queries the answer service ran to explain the result. */
  investigations?: number
}

export interface QueryOutcome {
  answer: string
  result: QueryResultSet
  conversationId: string | null
  analysis: QueryAnalysis
  /** "ok" for a normal answer; anything else means no real result — see message/suggestions. */
  status: 'ok' | 'needs_clarification' | 'failed_generic'
  /** Present when status !== 'ok'. User-facing explanation of why nothing could be answered. */
  message?: string
  /** Present when status !== 'ok'. Ready-to-submit example queries the user can try instead. */
  suggestions?: string[]
}

export interface ServiceHealth {
  status: string
  application: string
  version: string
  environment: string
}

export const EMPTY_RESULT_SET: QueryResultSet = {
  columns: [],
  rows: [],
  rowCount: 0,
  displayedRowCount: 0,
  truncated: false,
}

export const EMPTY_ANALYSIS: QueryAnalysis = {
  hasResults: false,
  usedLlm: false,
  isConversational: false,
}